module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-content sort-type",
    attrs: {
      "id": "act-list-template"
    }
  }, [_c('div', {
    staticClass: "job-list-container"
  }, [(_vm.list.length === 0) ? _c('div', [_c('div', {
    staticClass: "no-data"
  }, [_vm._v(_vm._s(_vm.infoText))])]) : _c('div', [_c('div', {
    staticClass: "job-card-grid"
  }, _vm._l((_vm.list), function(result) {
    return _c('div', {
      key: result.APP_NO,
      staticClass: "job-card"
    }, [_c('div', {
      staticClass: "card-header flex-justify-between"
    }, [(_vm.annKindType === 'JB') ? _c('span', {
      staticClass: "job-tag type2"
    }, [_vm._v("가치동행일자리")]) : (result.bizSe === 'IN49001') ? _c('span', {
      staticClass: "job-tag type1"
    }, [_vm._v("경력인재지원")]) : (result.bizSe === 'IN49003') ? _c('span', {
      staticClass: "job-tag type2"
    }, [_vm._v("채용설명회")]) : (result.bizSe === 'IN49006') ? _c('span', {
      staticClass: "job-tag type3"
    }, [_vm._v("40대 특화과정")]) : (result.bizSe === 'IN49007') ? _c('span', {
      staticClass: "job-tag type4"
    }, [_vm._v("시니어 인력뱅크")]) : (result.bizSe === 'IN49008') ? _c('span', {
      staticClass: "job-tag type5"
    }, [_vm._v("구인구직공고")]) : (result.bizSe === 'IN49009') ? _c('span', {
      staticClass: "job-tag type1"
    }, [_vm._v("4050 직업훈련")]) : (result.bizSe === 'IN49004') ? _c('span', {
      staticClass: "job-tag type2"
    }, [_vm._v("기타")]) : _vm._e(), _vm._v(" "), (result.ACT_ING_STEP_NM === '활동처미배치') ? _c('span', {
      staticClass: "status-badge status-darkblue"
    }, [_vm._v(_vm._s(result.ACT_ING_STEP_NM))]) : (result.ACT_ING_STEP_NM === '활동대기') ? _c('span', {
      staticClass: "status-badge status-darkblue"
    }, [_vm._v(_vm._s(result.ACT_ING_STEP_NM))]) : (result.ACT_ING_STEP_NM === '활동중') ? _c('span', {
      staticClass: "status-badge status-darkblue"
    }, [_vm._v(_vm._s(result.ACT_ING_STEP_NM))]) : (result.ACT_ING_STEP_NM === '활동종료') ? _c('span', {
      staticClass: "status-badge status-gray"
    }, [_vm._v(_vm._s(result.ACT_ING_STEP_NM))]) : (result.ACT_ING_STEP_NM === '활동포기') ? _c('span', {
      staticClass: "status-badge status-gray"
    }, [_vm._v(_vm._s(result.ACT_ING_STEP_NM))]) : (result.ACT_ING_STEP_NM === '중도포기 완료') ? _c('span', {
      staticClass: "status-badge status-gray"
    }, [_vm._v(_vm._s(result.ACT_ING_STEP_NM))]) : (result.ACT_ING_STEP_NM === '중도포기 신청중') ? _c('span', {
      staticClass: "status-badge status-darkblue"
    }, [_vm._v(_vm._s(result.ACT_ING_STEP_NM))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "card-body"
    }, [_c('a', {
      staticClass: "title-line",
      attrs: {
        "href": "javascript:void(0);",
        "title": "{{ result.ANN_NM }} 상세보기"
      }
    }, [_vm._v("\n              " + _vm._s(result.ANN_NM) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "recruitment-info long-type"
    }, [_c('span', [_vm._v("세부사업명 "), _c('strong', {
      staticClass: "bar"
    }, [_vm._v(_vm._s(result.BIZNM))])]), _vm._v(" "), _c('span', [_vm._v("활동처명 "), _c('strong', {
      staticClass: "bar"
    }, [_vm._v(_vm._s(result.ACTCOMP_NM))])]), _vm._v(" "), _c('span', [_vm._v("활동처 담당자 "), _c('strong', {
      staticClass: "bar",
      domProps: {
        "innerHTML": _vm._s(result.CHARGR_NM)
      }
    })]), _vm._v(" "), _c('span', [_vm._v("활동기간 "), _c('strong', {
      staticClass: "bar"
    }, [_vm._v(_vm._s(result.ACT_PART_DE))])])]), _vm._v(" "), _c('div', {
      staticClass: "button-area mypage-type1 mt-0"
    }, [_c('button', {
      staticClass: "btn btn-primary btn-md",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.goActJnlMonth(result.ANN_NO, result.ACTCOMP_NO, result.APP_NO)
        }
      }
    }, [_vm._v("활동일지 작성/조회")])])])])
  }), 0)]), _vm._v(" "), _c('pagination', {
    attrs: {
      "totalPages": _vm.paginationInfo.totalPageCount,
      "currentPage": _vm.paginationInfo.currentPageNo,
      "size": _vm.paginationInfo.pageSize
    },
    on: {
      "update:currentPage": [function($event) {
        return _vm.$set(_vm.paginationInfo, "currentPageNo", $event)
      }, _vm.handlePageChange],
      "update:current-page": function($event) {
        return _vm.$set(_vm.paginationInfo, "currentPageNo", $event)
      }
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77f65349"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/main/member/ACT/ActList.vue
// module id = 1467
// module chunks = 6